import { connect } from 'react-redux';
import SchedulesBoardFilter from './SchedulesBoardFilter';
import { selectSchedulesBoardStatusFilters } from '../Schedules.selectors';
import { setSchedulesBoardStatusFilters } from '../Schedules.reducers';
import { STATUS_FILTER_OPTIONS } from './SchedulesBoard.helpers';

const mapStateToProps = state => ({
  selectedFilterKeys: selectSchedulesBoardStatusFilters(state),
  filterOptions: STATUS_FILTER_OPTIONS,
  isStatusFilter: true,
});

const mapDispatchToProps = {
  setSchedulesBoardFilters: setSchedulesBoardStatusFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulesBoardFilter);
